import { render } from "./NotifMenu.html?vue&type=template&id=7cb890fe&ts=true&external"
import script from "./NotifMenu.ts?vue&type=script&lang=ts&external"
export * from "./NotifMenu.ts?vue&type=script&lang=ts&external"

import "./NotifMenu.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__